module.exports = __webpack_public_path__ + "img/credential3.fe16255f.png";